/* @flow */
import React from "react";
import { connect } from "react-redux";
import StavkaAudio from "../coins.mp3";
import LooseAudio from "../paper.mp3";
import "./iosAudioContext";

type Props = {};

type State = {
  stavkaBuffer: Object,
  stavkaLoaded: boolean,
  looseBuffer: Object,
  looseLoaded: boolean
};

class Audio extends React.Component<Props, State> {
  state = {
    stavkaBuffer: null,
    stavkaLoaded: false,
    looseBuffer: null,
    looseLoaded: false
  };

  audioContext: Object;

  load = (url: string) => {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'arraybuffer';

      request.onload = () => {
        this.audioContext.decodeAudioData(request.response, resolve, reject);
      };

      request.send();
    });
  };

  play = (buffer: Object) => {
    const source = this.audioContext.createBufferSource();
    source.buffer = buffer;
    source.connect(this.audioContext.destination);
    source.start(0);
  };

  UNSAFE_componentWillMount() {
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    window.audioctx = this.audioContext;

    this.load(StavkaAudio)
      .then(buffer => this.setState({ stavkaBuffer: buffer, stavkaLoaded: true }))
      .catch(error => console.error(error));

    this.load(LooseAudio)
      .then(buffer => this.setState({ looseBuffer: buffer, looseLoaded: true }))
      .catch(error => console.error(error));
  }

  componentWillUnmount() {
    this.audioContext && typeof this.audioContext.close === "function" && this.audioContext.close();
  }

  render () {
    const {
      stavkaBuffer,
      stavkaLoaded,
      looseBuffer,
      looseLoaded
    } = this.state;

    if (!(stavkaLoaded && looseLoaded)) return null;

    if (this.props.queue.length) {
      this.audioContext && typeof this.audioContext.resume === "function" && this.audioContext.resume();
      this.props.queue.forEach(soundEvent => {
        switch (soundEvent.type) {
          case "PLAY_WIN_SOUND":
            this.play(stavkaBuffer);
            this.props.finishSound(soundEvent.id);
            break;
          case "PLAY_LOOSE_SOUND":
            this.play(looseBuffer);
            this.props.finishSound(soundEvent.id);
            break;
          default:
            return null;
        }
      });
    }

    return null;
  }
};

type SoundProps = {
  play: string,
  dispatch: Function
};

class _Sound extends React.Component<SoundProps> {
  UNSAFE_componentWillMount() {
    this.props.dispatch({
      type: this.props.play,
      id: Date.now()
    });
  }

  render() {
    return null;
  }
};

export const Sound = connect()(_Sound);

export default connect((state) => {
  if (state.settings.sound) {
    return {
      queue: state.audio.queue
    };
  }

  return {
    queue: []
  };
}, dispatch => {
  return {
    finishSound(timestamp) {
      dispatch({
        type: "REMOVE_SOUND",
        payload: timestamp
      });
    }
  }
})(Audio);


// WEBPACK FOOTER //
// ./src/components/Audio.js